module.exports = __webpack_public_path__ + "static/img/banner2.225ff54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/banner2.jpg
// module id = P+IB
// module chunks = 1